/** 物流费率-新 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/lgit/v1/{organizationId}/customer/logistics',
  items: [
  // 三合一页面 列表页
    // 物流费率列表页   post /v1/{organizationId}/customer/logistics/config/pageList
    { key: 'getLogisticNewRate', url: '/config/pageList', method: 'POST' },
    // 物流费率新增     post /v1/{organizationId}/customer/logistics/config/add
    { key: 'addLogisticNewRate', url: '/config/add', method: 'POST' },
    // 物流费率复制     post /v1/{organizationId}/customer/logistics/config/copy
    { key: 'copyLogisticNewRate', url: '/config/copy', method: 'POST' },
    // 物流费率删除     delete /v1/{organizationId}/customer/logistics/config/delete
    { key: 'delLogisticNewRate', url: '/config/delete', method: 'DELETE' },

  // 三合一页面 第一弹出框
    // 客户物流名称列表     post /v1/{organizationId}/customer/logistics/name/pageList
    { key: 'getLogisticName', url: '/name/pageList', method: 'POST' },
    // 客户物流名称新增     post /v1/{organizationId}/customer/logistics/name/add
    { key: 'addLogisticName', url: '/name/add', method: 'POST' },
    // 客户物流名称新增     post /v1/{organizationId}/customer/logistics/name/copy
    { key: 'copyLogisticName', url: '/name/copy', method: 'POST' },
    // 客户物流名称删除     delete /v1/{organizationId}/customer/logistics/name/delete
    { key: 'delLogisticName', url: '/name/delete', method: 'DELETE' },

  // 三合一页面 第二弹出框
    // 客户物流名称分组列表     post /v1/{organizationId}/customer/logistics/group/pageList
    { key: 'getLogisticGroup', url: '/group/pageList', method: 'POST' },
    // 客户物流名称分组新增     post /v1/{organizationId}/customer/logistics/group/add
    { key: 'addLogisticGroup', url: '/group/add', method: 'POST' },
    // 客户物流名称分组编辑     post /v1/{organizationId}/customer/logistics/group/update
    { key: 'editLogisticGroup', url: '/group/update', method: 'POST' },
    // 客户物流名称分组删除     delete /v1/{organizationId}/customer/logistics/group/delete
    { key: 'delLogisticGroup', url: '/group/delete', method: 'DELETE' },
    // 下拉接口        post /v1/{organizationId}/customer/logistics/group/dict/list
    { key: 'getLogisticGroupdict', url: '/group/dict/list', method: 'POST' },

  // zone group 列表页
    // 列表页 post /v1/{organizationId}/customer/logistics/group/dict/pageList
    { key: 'getLogisticGroupList', url: '/group/dict/pageList', method: 'POST' },
    // 新增   post /v1/{organizationId}/customer/logistics/group/dict/add
    { key: 'addLogisticGroupList', url: '/group/dict/add', method: 'POST' },
    // 编辑   post /v1/{organizationId}/customer/logistics/group/dict/update
    { key: 'updateLogisticGroupList', url: '/group/dict/update', method: 'POST' },
    // 复制   post /v1/{organizationId}/customer/logistics/group/dict/copy
    { key: 'copyLogisticGroupList', url: '/group/dict/copy', method: 'POST' },
    // 删除   delete /v1/{organizationId}/customer/logistics/group/dict/delete
    { key: 'delLogisticGroupList', url: '/group/dict/delete', method: 'DELETE' },

  // zone detail 详情页
    // 列表   post /v1/{organizationId}/customer/logistics/group/detail/pageList
    { key: 'getLogisticGroupDetail', url: '/group/detail/pageList', method: 'POST' },
    // 新增   post /v1/{organizationId}/customer/logistics/group/detail/add
    { key: 'addLogisticGroupDetail', url: '/group/detail/add', method: 'POST' },
    // 编辑   post /v1/{organizationId}/customer/logistics/group/detail/update
    { key: 'updateLogisticGroupDetail', url: '/group/detail/update', method: 'POST' },
    // 删除   delete /v1/{organizationId}/customer/logistics/group/detail/delete
    { key: 'delLogisticGroupDetail', url: '/group/detail/delete', method: 'DELETE' },

    // 新增客户物流名称分组详情（批量新增,导入用）   post /v1/{organizationId}/customer/logistics/group/detail/addBatch
    { key: 'getLogisticGroupDetailList', url: '/group/detail/addBatch', method: 'POST' },

  // 物流产品
    // 获取物流产品列表   post /v1/{organizationId}/customer/logistics/product/pageList
    { key: 'getLogisticProductList', url: '/product/pageList', method: 'POST' },
    // 新增物流产品       post /v1/{organizationId}/customer/logistics/product/add
    { key: 'addLogisticProductList', url: '/product/add', method: 'POST' },
    // 编辑物流产品       post /v1/{organizationId}/customer/logistics/product/update
    { key: 'editLogisticProductList', url: '/product/update', method: 'POST' },
    // 删除物流产品       delete /v1/{organizationId}/customer/logistics/product/delete
    { key: 'delLogisticProductList', url: '/product/delete', method: 'DELETE' },
    // 物流产品设置 顶部详情信息       get /v1/{organizationId}/customer/logistics/product/{id}
    { key: 'getLogisticProductSettingInfo', url: '/product/{id}', method: 'GET' },
  ],
};
export default {
  ...generate(config),
};
